import React from "react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {APP_API_URL} from "../../../constans/global";
import {auxiliaryApi} from "../../../constans/apiUrls";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import {ErrorMessage} from "formik";
import {isNotEmpty} from "../../../helpers/functions";

interface IMyCKEditorProps {
    name: string,
    label?: string,
    placeholder?: string,
    inputClassName?: string,
    errorClassName?: string,
    labelClassName?: string,
    isRequired?: boolean,
    meta?: any,
    defaultValue?: any,
    subContent?: string,
    handleChangeValue: any
}

const MyCKEditor: React.FC<IMyCKEditorProps> = ({
                                                    name,
                                                    inputClassName = null,
                                                    label = null,
                                                    placeholder = null,
                                                    errorClassName = null,
                                                    labelClassName = null,
                                                    isRequired = false,
                                                    defaultValue,
                                                    meta,
                                                    subContent = "",
                                                    handleChangeValue
                                                }) => {
    return (
        <React.Fragment>
            <div className={"mb-5"}>
                {label &&
                    <div
                        className={`pr-1 mb-2 block text-md font-medium text-gray-500 flex items-center ${labelClassName ?? null}`}>
                        <span className={"ml-1"}>{label}</span>
                        {isRequired && <span className={"text-xl text-red-500"}>*</span>}
                    </div>
                }
                <div>
                    <CKEditor
                        id={name}
                        editor={ClassicEditor}
                        data={isNotEmpty(defaultValue) ? defaultValue : placeholder}
                        config={{
                            ckfinder: {
                                uploadUrl: `${APP_API_URL}/${auxiliaryApi.upload_image}`
                            },
                            mediaEmbed: {
                                previewsInData: true,
                                providers: [
                                    {
                                        name: 'youtube',
                                        url: [
                                            /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/,
                                            /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/,
                                            /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/,
                                            /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/
                                        ],
                                        html: match => {
                                            const id = match[1];
                                            const time = match[2];

                                            return (
                                                '<div class="blog-video" style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
                                                `<iframe src="https://www.youtube.com/embed/${id}${time ? `?start=${time}` : ''}" ` +
                                                'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                                                'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' +
                                                '</iframe>' +
                                                '</div>'
                                            );
                                        }
                                    },
                                    {
                                        name: 'aparat',
                                        url: [
                                            /^https:\/\/www\.aparat\.com\/v\/([\w-]+)/,
                                        ],
                                        html: match => {
                                            const key = match[1];
                                            return (
                                                '<div class="blog-video" style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
                                                `<iframe src="https://www.aparat.com/video/video/embed/videohash/${key}/vt/frame?titleShow=true" ` +
                                                'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"' +
                                                'allowfullscreen webkitallowfullscreen mozallowfullscreen>' +
                                                '</iframe>' +
                                                '</div>'
                                            );
                                        }
                                    },
                                    {
                                        name: 'asasarmaye',
                                        url: [
                                            /^dl.asasarmaye\.com\/blog\/([\w-]+)/,
                                        ],
                                        html: match => {
                                            const key = match[1];
                                            return (
                                                '<div class="blog-video" style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
                                                `<video src="https://dl.asasarmaye.com/blog/${key}" ` +
                                                'type="video/mp4" controls loop width="100%" height="500px">' +
                                                '</video>' +
                                                '</div>'
                                            );
                                        }
                                    },
                                ]
                            },
                        }}
                        // onReady={editor => {
                        //     console.log('Editor is ready to use!', editor);
                        // }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            handleChangeValue(data)
                            // console.log({event, editor, data});
                        }}
                        // onBlur={(event, editor) => {
                        //     console.log('Blur.', editor);
                        // }}
                        // onFocus={(event, editor) => {
                        //     console.log('Focus.', editor);
                        // }}
                    />
                    {subContent && isNotEmpty(subContent) &&
                        <div className={"text-gray-500 text-sm text-right mt-1 mr-1"}>{subContent}</div>}
                    <div className={"mt-1 mr-1"}>
                        <ErrorMessage name={name}
                                      className={`text-red-500 text-sm text-right ${errorClassName ?? null}`}
                                      component={"div"}/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default MyCKEditor